import { Buffer } from 'buffer';
import { useSelector } from 'react-redux';

export function Decrptdata(datas) {
  const { getProfile } = useSelector((state) => state?.ProfileSlice);

  const decodeBase64 = (data) => {
    return Buffer.from(data, 'base64').toString('ascii');
  };

  const decrptData = (value) => {
    const letters = value && value?.slice(0, -1);
    return value
      ? decodeBase64(`${letters}${getProfile?.userId}`).replace(
          '{',
          ''
        )
      : '';
  };

  return decrptData(datas);
}
